import styled, { css } from "styled-components";

export default styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5rem;
  padding: 0.6rem 0.8rem;
  ${({ theme }) => css`
    background: ${theme.colors.darkRed};
    color: white;
  `}
`;
